import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Infinity as InfinityIcon } from "lucide-react";

function navClass({ isActive }) {
  return `flex items-center gap-3 px-4 py-2.5 rounded-md text-sm font-heading font-medium ${
    isActive ? "bg-[#156F5B]/10 text-[#156F5B]" : "text-[#4D4D4D] hover:bg-[#F3F8F7] hover:text-[#212121]"
  }`;
}

const NAV_TRANSITION = { transition: "color .2s ease, background-color .2s ease" };

export function Sidebar({ nav }) {
  return (
    <aside className="hidden md:flex flex-col w-64 shrink-0 bg-white border-r border-[#E5E7EB] sticky top-0 h-screen overflow-y-auto">
      <div className="px-6 py-6 border-b border-[#E5E7EB] shrink-0">
        <Link to="/dashboard" className="flex items-center gap-2" data-testid="brand-link">
          <InfinityIcon className="h-7 w-7 text-[#156F5B]" strokeWidth={2.5} />
          <span className="text-2xl font-bold font-heading tracking-wide text-[#156F5B]">KOIOC</span>
        </Link>
        <div className="mt-1.5 k-sublabel">Data Analytics Portal</div>
      </div>
      <nav className="flex-1 px-3 py-6 space-y-1">
        {nav.map((n) => (
          <NavLink key={n.to} to={n.to} data-testid={n.testId} className={navClass} style={NAV_TRANSITION}>
            <n.icon className="h-4 w-4" />
            <span>{n.label}</span>
            {n.badge > 0 && (
              <span
                className="ml-auto inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-red-100 border border-red-200 text-red-600 text-[11px] font-semibold"
                data-testid="alerts-nav-badge"
              >
                {n.badge}
              </span>
            )}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
